import { Dialog } from "primereact/dialog";
import "./LanguageChangePopup.scss";
import { useEffect, useState } from "react";
import leftArrow from '../../assets/images/left-arrow.png'
import { useTranslation } from 'react-i18next'
import closeIcon from '../../assets/images/closeIcon.svg'

export const LanguageChangePopup = ({
    isVisible,
    headerComponent,
    body,
    footerPriBtnLabel,
    // footerSecBtnLabel,
    footerPriBtnClick,
    // footerSecBtnClick,
    onClose,
    className,
    children,
    showMobileBackButton = false,
    isOnlyHeader = false,
    ...props
}) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
        };

        const lockScrollIfMobile = () => {
            if (isVisible && window.innerWidth < 992) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        };

        handleResize();
        lockScrollIfMobile();

        window.addEventListener('resize', handleResize);
        window.addEventListener('resize', lockScrollIfMobile);

        return () => {
            document.body.style.overflow = '';
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('resize', lockScrollIfMobile);
        };
    }, [isVisible]);

    const { t } = useTranslation(['labels', 'errors']);
    const { mainHeader, subHeader } = headerComponent || {};

    return (
        <Dialog
            // footer={
            //     <>
                   
            //         {footerPriBtnLabel && (
            //             <button
            //                 type="button"
            //                 className="cust-popup-footer-pri-btn primary-button"
            //                 onClick={footerPriBtnClick}
            //             >
            //                 {footerPriBtnLabel}
            //             </button>
            //         )}
            //     </>
            // }
            showHeader
            onHide={()=> {}}
            visible={isVisible}
            modal
            closable={false}
            header={
                <div className="cust-popup-header">
                    {showMobileBackButton && isMobile && (
                        <button className="back-button" onClick={footerSecBtnClick || onClose}>
                            <img
                                src={leftArrow}
                                alt="Back"
                                className="left-arrow-btn"
                            />
                            {t('COMMON.BACK_BUTTON')}
                        </button>
                    )}

                    <div className={`cust-popup-header-titles ${isOnlyHeader ? "only-header-case" : ""}`}>
                        <div className="header-left">
                            {mainHeader && <label className="popup-header-main">{mainHeader}</label>}
                            {subHeader && <label className="popup-header-sub">{subHeader}</label>}
                        </div>
                        <img src={closeIcon} className="close-icon" onClick={onClose} title="Close" />
                    </div>

                </div>
            }
            className={`custom-popup-lan ${isOnlyHeader ? "only-header-case" : ""} ${className || ""}`}
            {...props}
        >
            {body}
            <div className="body">{children}</div>
            {footerPriBtnLabel && (
            // <div className="popup-body-footer">
                <button
                    type="button"
                    className="cust-popup-footer-pri-btn primary-button"
                    onClick={footerPriBtnClick}
                >
                    {footerPriBtnLabel}
                </button>
            // </div>
        )}
        </Dialog>
    );
};
